import { Routes } from '@angular/router';
import { PrivacyPolicyComponent } from './pages/privacy-policy.component';

export const PRIVACY_POLICY_ROUTES: Routes = [
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
    },
];
